<template>
  <div class="flex flex-col space-y-2 md:flex-row-reverse md:space-y-0 md:space-x-2 md:space-x-reverse p-standard w-full *:w-full *:text-sm *:shrink">
    <vetster-button
      v-if="primaryActionLabel"
      :disabled="disabled"
      :variant="primaryActionVariant"
      :class="actionClass"
      class="space-x-2"
      @click="$emit('primary-action')"
    >
      <fa
        v-if="primaryActionIcon"
        :icon="primaryActionIcon"
        class="text-xl"
      />
      <span>{{ primaryActionLabel }}</span>
    </vetster-button>
    <vetster-button
      v-if="secondaryActionLabel"
      :disabled="disabled"
      :variant="secondaryActionVariant"
      :class="actionClass"
      @click="$emit('secondary-action')"
    >
      {{ secondaryActionLabel }}
    </vetster-button>
  </div>
</template>

<script>
export default {
  name: 'VetsterSlideOverCommonFooter',

  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    primaryActionIcon: {
      type: Array,
      default: null,
    },
    primaryActionLabel: {
      type: String,
      default: undefined,
    },
    primaryActionVariant: {
      type: String,
      default: 'ocean',
    },
    secondaryActionLabel: {
      type: String,
      default: undefined,
    },
  },

  computed: {
    actionClass() {
      return (this.primaryActionLabel && this.secondaryActionLabel) ?? 'sm:w-1/2';
    },
    secondaryActionVariant() {
      return this.$screen('mobile') ? 'darkLink' : 'outlineNeutral';
    },
  },
};
</script>
